import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';

import Spinner from '../../../components/ui/spinner';
import { useAppSelector } from '../../../store';

const Accordion = withStyles({
    root: {
        justifyContent: 'space-between',
        borderRadius: '12px 12px 0 0',
        boxShadow: 'none',
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
    root: {
        backgroundColor: 'white',
        borderRadius: '12px 12px 0 0',
        borderBottom: '1px solid #EDEDED',
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        minHeight: 56,
        padding: '0 26px 0 20px',
        '&$expanded': {
            minHeight: 56,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles(theme => ({
    root: {
        borderBottom: '1px solid #EDEDED',
        display: 'block',
        padding: '20px 50px 20px 25px',
    },
}))(MuiAccordionDetails);

const NoticeCollapse = () => {
    const [expanded, setExpanded] = React.useState<string | false>('panel1');
    const { bulletin } = useAppSelector(state => state.moments);
    const { words } = useAppSelector(state => state.localization);

    const handleChange = (panel: string) => (event, newExpanded: boolean) => {
        setExpanded(newExpanded ? panel : false);
    };


    if (bulletin.loading) {
        return <Spinner />;
    }

    return (
        <div className="bulletin-menu">
            <Accordion square expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                    <a href="#!" className="button-03">
                        <svg className="icon-bulletin" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="30" height="30" rx="8" fill="#D3D3D8" />
                            <path d="M7.5 14.1667L22.5 10V20L7.5 16.6667V14.1667Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M14.6666 19C14.5791 19.3174 14.4299 19.6144 14.2276 19.8741C14.0252 20.1338 13.7737 20.3511 13.4874 20.5136C13.2011 20.6761 12.8856 20.7806 12.5589 20.8212C12.2322 20.8617 11.9007 20.8375 11.5833 20.75C11.2659 20.6624 10.9689 20.5132 10.7092 20.3109C10.4495 20.1086 10.2322 19.8571 10.0697 19.5708C9.90723 19.2844 9.80271 18.9689 9.76215 18.6422C9.72158 18.3155 9.74576 17.984 9.83331 17.6667" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <span className="text-01">{words && words['WEB.announcements']}</span>
                        <svg
                            className={expanded ? 'active accordion-arrow' : 'accordion-arrow'}
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 18L15 12L9 6" stroke="#6C6C7D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </a>
                </AccordionSummary>
                {bulletin.items?.map((notice, index) => {
                    return (
                        <AccordionDetails key={notice.id}>
                            {/* <a
                                href="#!"
                                // onClick={() => handleChangePage('bulletin', index.toString())}
                                className={
                                    page === 'bulletin' && activeMenuContentPage === index.toString() ? 'bulletin-menu active' : 'bulletin-menu'
                                }>
                                <p className="bulletin-menu-content"> {notice.header}</p>
                            </a> */}

                            <p className="bulletin-menu-content"> {notice.header}</p>

                        </AccordionDetails>
                    );
                })}
            </Accordion>
        </div>
    );
};

export default NoticeCollapse;
